const Home = () =>
    import(/* webpackChunkName: "home-chunk" */ './Home')

export default [{
    path: '',
    component: Home
}]